const styleProperties = {
    colorBackgroundBase: '#efefef',
    colorAccentLight: '#e9f3f0',
    colorBackgroundNewItem: 'rgba(79, 195, 247, .09)',
    colorBackgroundNewItemHover: 'rgba(79, 195, 247, .2)',

    widthLeftPanel: '320px',
    widthRightPanel: '256px',
    widthRightPanelLarge: '360px',
    widthNavbarRight: '50px',
    widthResponseFilters: '240px',
    radiusPanelBorder: '5px',
    heightTimelineMainContent: '128px',
    panelBorderRadius: '5px',

    fontSizeExtraSmall: '12px',
    fontSizeSmall: '14px',
    fontSizeMedium: '16px',
    fontSizeLarge: '18px',
    fontSizeExtraLarge: '22px',

    fontSizeUltraLarge: '32px',
    fontSizeUltraLargeAlt: '48px',

    fontSizeActionButton: '24px',

    widthDisplayPicture: '54px',
    heightDisplayPicture: '54px',

    colorPrimary: '#303f9f',
    colorAccent: '#18bc9c',
    colorDanger: '#d32f2f',

    colorGrey: '#B0BEC5',
    colorTextOnGrey: 'var(--color-text-on-light)',

    colorYellow: '#FFE082',
    colorTextOnYellow: 'var(--color-text-on-light)',

    colorGreen: '#81C784',
    colorTextOnGreen: 'var(--color-text-on-light)',

    widthFloatingActionButton: '54px',
    heightFloatingActionButton: '54px',

    widthBadgeMax: '26vw',

    widthContentMax: '900px',
};

export default styleProperties;
